"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Samples = void 0;
const Client_1 = require("../resources/audio/client/Client");
class Samples {
    constructor(_options = {}) {
        this._options = _options;
    }
    get audio() {
        var _a;
        return ((_a = this._audio) !== null && _a !== void 0 ? _a : (this._audio = new Client_1.Audio(this._options)));
    }
}
exports.Samples = Samples;
